import React from 'react';
import { MinusSvg, PlusSvg, TrashIcon } from '../../assets/icons/shop/Svg';
import { onlyNumbersFormat } from '../../utilities/functions';
import { twMerge } from 'tailwind-merge';

const MAX_QUANTITY = 5;
const regex = new RegExp(`^[0-${MAX_QUANTITY}]?$`);

interface Props {
  currentQuantity: number | string;
  increase: () => void;
  decrease: () => void;
  onChange: (amount: number) => void;
  withTrashIcon?: boolean;
  isLoading?: boolean;
  containerClassName?: string;
}

const EditQuantityCell = ({
  currentQuantity,
  increase,
  decrease,
  onChange,
  withTrashIcon,
  isLoading,
  containerClassName,
}: Props) => {
  const handleOnInput = (event: React.FormEvent<HTMLInputElement>) => {
    const inputElement = event.currentTarget;
    if (!regex.test(inputElement.value)) {
      inputElement.value = inputElement.value.slice(0, -1);
    }
  };

  return (
    <div
      className={twMerge(
        'flex items-center justify-start desktop:justify-center gap-2',
        containerClassName,
      )}
    >
      <button
        onClick={decrease}
        disabled={!currentQuantity || isLoading}
        className="!outline-none"
        type="button"
      >
        {withTrashIcon && currentQuantity === 1 && (
          <TrashIcon
            className={twMerge(
              'w-6 desktop:w-7 h-6 desktop:h-7',
              isLoading ? 'fill-granite-grey' : 'fill-clc-blue',
            )}
          />
        )}
        {(!withTrashIcon || currentQuantity > 1) && (
          <MinusSvg
            className={twMerge(
              'w-6 desktop:w-7 h-6 desktop:h-7',
              currentQuantity ? 'stroke-clc-blue' : 'stroke-granite-grey',
              isLoading && 'stroke-granite-grey',
            )}
          />
        )}
      </button>
      <input
        value={currentQuantity}
        className="h-[30px] desktop:h-10 w-[46px] desktop:w-10 bg-transparent border border-granite-grey rounded-lg  text-center outline-none focus:border-blue-400"
        onChange={(event) => {
          onChange(Number(onlyNumbersFormat(event.target.value)));
        }}
        onInput={handleOnInput}
        disabled={isLoading}
      />
      <button
        onClick={increase}
        className={twMerge('!outline-none')}
        disabled={isLoading || currentQuantity >= MAX_QUANTITY}
        type="button"
      >
        <PlusSvg
          className={twMerge(
            'w-6 desktop:w-7 h-6 desktop:h-7',
            isLoading || currentQuantity >= MAX_QUANTITY
              ? 'stroke-granite-grey'
              : 'stroke-clc-blue',
          )}
        />
      </button>
    </div>
  );
};

export default EditQuantityCell;
